import { render, staticRenderFns } from "./AddItemsModal.vue?vue&type=template&id=18666e12&"
import script from "./AddItemsModal.vue?vue&type=script&lang=js&"
export * from "./AddItemsModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "AddItemsModal.vue"
export default component.exports